import { colors, FelaCSS, spacing, TSpacingValue } from '@bridebook/ui';

interface IStyleProps {
  slideSpeed: number;
  slidePosition: number;
  slideWidth: number;
  headerTitle: boolean;
  gap?: TSpacingValue;
}

interface IStyles {
  carouselTitle: FelaCSS;
  headerControlsWrapper: FelaCSS;
  wrapper: FelaCSS;
  buttonPrevious: FelaCSS;
  buttonNext: FelaCSS;
  heading: FelaCSS;
  iconWrapBack: FelaCSS;
  iconWrapNext: FelaCSS;
  viewContainer: FelaCSS;
  slidesContainer: FelaCSS;
  nextChevron: FelaCSS;
  prevChevron: FelaCSS;
  controls: FelaCSS;
  buttonBehavior: FelaCSS;
  slideWrapper: FelaCSS;
}

const styles = ({
  slideSpeed,
  slidePosition,
  slideWidth,
  headerTitle,
  gap,
}: IStyleProps): IStyles => {
  const buttonShared: FelaCSS = {
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    border: 'none',
    borderRadius: '100%',
    backgroundColor: colors.space,
  };

  return {
    wrapper: {
      userSelect: 'none',
    },

    buttonPrevious: {
      ...buttonShared,
      left: 3,
    },

    buttonNext: {
      ...buttonShared,
      right: 3,
    },

    heading: {
      marginVertical: 0,
      minWidthDesktop: {
        fontDefaultSemiBold: 30,
      },
    },

    iconWrapBack: {
      transform: 'rotate(90deg)',
    },

    iconWrapNext: {
      transform: 'rotate(270deg)',
    },

    viewContainer: {
      overflow: 'hidden',
    },

    slidesContainer: {
      flexDirection: 'row',
      alignItems: 'stretch',
      transitionDuration: `${slideSpeed}ms`,
      transform: `translate3d(${slidePosition}px, 0, 0)`,
    },

    headerControlsWrapper: {
      flexDirection: 'row',
      justifyContent: headerTitle ? 'space-between' : 'end',
      alignItems: 'center',
      paddingBottom: spacing[5],
    },

    carouselTitle: {
      fontDefaultSemiBold: 18,
    },

    nextChevron: {
      transform: 'rotate(270deg)',
      marginHorizontal: 3,
    },
    prevChevron: {
      transform: 'rotate(90deg)',
      marginHorizontal: 3,
    },
    controls: {
      display: 'flex',
      flexDirection: 'row',
      gap: spacing[4],
      justifyContent: 'flex-end',
      alignSelf: 'end',
      alignItems: 'center',
    },
    buttonBehavior: {
      width: '32px',
      height: '32px',
      marginLeft: 2,
      ':hover': {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: colors.space15,
        borderRadius: '4px',
      },
      ':active': {
        background: colors.space04,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: colors.space15,
        borderRadius: '4px',
      },
    },
    slideWrapper: {
      flexShrink: 0,
      width: slideWidth,
      ':not(:first-of-type)': {
        paddingLeft: gap ?? 4,
      },
      ':first-of-type': {
        width: slideWidth - 16,
      },
    },
  };
};

export default styles;
